const pixType = {
  PIX_KEY: 'PIX_KEY',
  BANK_ACCOUNT: 'BANK_ACCOUNT'
};

module.exports = pixType;
